var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card border-success shadow-none mb-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c(
            "div",
            {
              staticClass: "font-weight-bold text-truncate",
              attrs: { title: _vm.anexo.name_file },
            },
            [
              _vm._v(
                "\n                    @" +
                  _vm._s(_vm.anexo.name_file) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-muted font-size-08" }, [
            _c("span", { staticClass: "badge badge-success mr-2" }, [
              _vm._v("PDF"),
            ]),
            _vm._v(" "),
            _vm.tamanhoFormatado
              ? _c("span", { staticClass: "mr-2" }, [
                  _vm._v("@" + _vm._s(_vm.tamanhoFormatado)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.dataFormatada
              ? _c("span", [_vm._v("Enviado em @" + _vm._s(_vm.dataFormatada))])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-sm btn-outline-primary mr-1",
              attrs: {
                href: _vm.anexo.download,
                target: "_blank",
                rel: "noopener",
                "aria-label": "Download de " + _vm.anexo.name_file,
                title: "Download",
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-download",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-md-inline ml-1" }, [
                _vm._v("Download"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-secondary mr-1",
              attrs: {
                type: "button",
                "aria-label": "Substituir lista",
                title: "Substituir lista",
              },
              on: {
                click: function ($event) {
                  return _vm.substituir()
                },
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-sync-alt",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-md-inline ml-1" }, [
                _vm._v("Substituir"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-danger",
              attrs: {
                type: "button",
                id: "btn-remover-" + _vm.refresh_emit,
                "aria-label": "Remover lista",
                title: "Remover lista",
              },
              on: {
                click: function ($event) {
                  return _vm.remover()
                },
              },
            },
            [
              _c("i", {
                staticClass: "far fa-trash-alt",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-md-inline ml-1" }, [
                _vm._v("Remover"),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", {
        staticClass: "far fa-file-pdf text-danger icone-pdf",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }